import { render, staticRenderFns } from "./CTC.vue?vue&type=template&id=4d6bbb9c&scoped=true"
import script from "./CTC.vue?vue&type=script&lang=js"
export * from "./CTC.vue?vue&type=script&lang=js"
import style0 from "./CTC.vue?vue&type=style&index=0&id=4d6bbb9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bbb9c",
  null
  
)

export default component.exports